import { API_ROUTES } from "../../../../../../shared/app-configs/sc-app-config";
import { TCAppConfig } from "../../../../../../shared/app-configs/tc-app-configs";
import {
  FacilityInformation,
  FacilityProcessDetails,
  FacilityState,
} from "../../../sc-models/facility-product-dto";

/**
 * Fetch facility details using the given API caller.
 *
 * @param executeGet - The API call function from your custom hook.
 * @param scId - The scId query parameter.
 * @param facilityId - The facility identifier.
 * @returns A promise that resolves with the facility details.
 * @throws An error if the fetch fails.
 */
export async function fetchFacilityDetails(
  executeGet: (url: string, params: Record<string, any>) => Promise<any>,
  scId: string,
  facilityId: string
): Promise<any> {
  if (!facilityId) return null;
  try {
    const response = await executeGet(API_ROUTES.GET_FACILITY_DETAILS_V4, {
      scId,
      facilityId,
    });
    return response;
  } catch (err) {
    console.error("Error fetching facility details:", err);
    throw new Error("Failed to load facility details.");
  }
}
export const mapFacilityDetails = (data: { facilityDetails: any[] }): any[] => {
  if (!Array.isArray(data.facilityDetails)) {
    throw new Error("Invalid facility details: Expected an array");
  }

  return data.facilityDetails.map((facility, index) => {
    // Required field validation
    if (!facility.facilityNo || !facility.facilityName) {
      throw new Error(`Missing required fields in facility at index ${index}`);
    }

    const facilityInfo = {
      isMainSite: facility.isMainSite || "N",
      facilityNo: facility.facilityNo || "",
      facilityType: facility.facilityType || "",
      facilityOsId: facility.facilityOsId || "",
      lastAuditDate: facility.facilityLastAuditDate || "",
      facilityAddedDate: facility?.facilityAddedDate || "",
      facilityRemovedDate: facility?.facilityRemovedDate || "",
      facilityLastAuditDate: facility?.facilityLastAuditDate || "",
      facilityFarmCapacityInformation:
        facility.facilityFarmCapacityInformation || [],
      facilityProductionCapacity: facility?.facilityProductionCapacity || undefined,
      facilityAdditionalScopes: facility?.facilityAdditionalScopes || "",
      facilityTeId: facility.facilityTeId || "",
      facilityStandard: facility.facilityStandard || [],
      facilityName: facility.facilityName || "",
      facilityAddress1: facility.facilityAddress1 || "",
      facilityAddress2: facility.facilityAddress2 || "",
      facilityAddress3: facility.facilityAddress3 || "",
      facilityPostcode: facility.facilityPostcode || "",
      facilityTown: facility.facilityTown || "",
      facilityCountryOrArea: facility.facilityCountryOrArea || "",
      facilityStateOrProvince: facility.facilityStateOrProvince || "",
      facilityCbOfIndependentlyCertifiedSubcontractor:
        facility?.facilityCbOfIndependentlyCertifiedSubcontractor || "",
    };

    const facilityProcessDetails = (facility.facilityProcessDetails || []).map(
      (process: any) => ({
        facilityProcessCategoryCode: process.facilityProcessCategoryCode || "",
        facilityProcessCategoryUserSpecificTerm:
          process.facilityProcessCategoryUserSpecificTerm || "",
      })
    );

    return {
      facilityInfo,
      facilityProcessDetails,
    };
  });
};

export function convertFacilityData(rawData: any): FacilityState {
  const facility = rawData;
  const facilityInfo: FacilityInformation = {
    isMainSite: facility.isMainSite || "",
    facilityNo: facility.facilityNo || "",
    facilityType: facility.facilityType || "",
    facilityOsId: facility.facilityOsId || "",
    facilityAddedDate: facility.facilityAddedDate || "",
    facilityRemovedDate: facility.facilityRemovedDate || "",
    facilityLastAuditDate: facility.facilityLastAuditDate || "",
    facilityAdditionalScopes: facility.facilityAdditionalScopes || "",
    facilityProductionCapacity: facility.facilityProductionCapacity || undefined,
    facilityTeId: facility.facilityTeId || "",
    facilityStandard: facility.facilityStandard || [],
    facilityName: facility.facilityName || "",
    facilityAddress1: facility.facilityStreetAddress || "",
    facilityAddress2: facility.facilityAddress2 || "",
    facilityAddress3: facility.facilityAddress3 || "",
    facilityPostcode: facility.facilityPostcode || "",
    facilityTown: facility.facilityTown || "",
    facilityCountryOrArea: facility.facilityCountryOrArea || "",
    facilityStateOrProvince: facility.facilityStateOrProvince || "",
    // subcontractorLicenseNo: facility.facilitySubcontractorLicenseNo || '',
    facilityCbOfIndependentlyCertifiedSubcontractor:
      facility.facilityCbOfIndependentlyCertifiedSubcontractor || "",
    // expiryDate: facility.facilityExpiryDateOfIndependentlyCertifiedSubcontractor || '',
  };

  const facilityProcessDetails: FacilityProcessDetails[] = (
    facility.facilityProcessInformation || []
  ).map((process: any) => ({
    facilityProcessCategoryCode: process.facilityProcessCategoryCode || "",
    facilityProcessCategoryUserSpecificTerm:
      process.facilityProcessCategoryUserSpecificTerm || "",
  }));
  console.log(facilityProcessDetails, "det");
  return {
    facilityInfo,
    facilityProcessInformation:facilityProcessDetails,
    facilityFarmCapacityInformation:
      facility?.facilityFarmCapacityInformation || [],
  };
}
